import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { IBrandState } from "./types";

const initialState: IBrandState = {
  brand: {
    status: undefined,
    data: null,
    error: undefined,
  },
  findWheeler: {},
  findIdByProduct: {},
  findModelById:{}
};

const slice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    brand(state, action: PayloadAction) {
      state.brand.status = RequestStatus.RUNNING;
    },
    brandSuccess(state, action) {
      state.brand.status = RequestStatus.SUCCESS;
      state.brand.data = action.payload;
    },
    brandFailed(state, action: PayloadAction<any>) {
      state.brand.status = RequestStatus.ERROR;
      state.brand.error = action.payload;
    },
    findWheelers(state, action: PayloadAction) {
      state.findWheeler.status = RequestStatus.RUNNING;
    },
    findWheelersSuccess(state, action) {
      state.findWheeler.status = RequestStatus.SUCCESS;
      state.findWheeler.data = action.payload;
    },
    findWheelersFailed(state, action: PayloadAction<any>) {
      state.findWheeler.status = RequestStatus.ERROR;
      state.findWheeler.error = action.payload;
    },
    findProductIdBy(state, action: PayloadAction<{ id: any }>) {
      state.findIdByProduct.status = RequestStatus.RUNNING;
    },
    findProductIdBySuccess(state, action) {
      state.findIdByProduct.status = RequestStatus.SUCCESS;
      state.findIdByProduct.data = action.payload;
    },
    findProductIdByFailed(state, action: PayloadAction<any>) {
      state.findIdByProduct.status = RequestStatus.ERROR;
      state.findIdByProduct.error = action.payload;
    },
    findModelById(state, action: PayloadAction<{ id: any }>) {
      state.findModelById.status = RequestStatus.RUNNING;
    },
    findModelByIdSuccess(state, action) {
      state.findModelById.status = RequestStatus.SUCCESS;
      state.findModelById.data = action.payload;
    },
    findModelByIdFailed(state, action: PayloadAction<any>) {
      state.findModelById.status = RequestStatus.ERROR;
      state.findModelById.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  brand,
  brandSuccess,
  brandFailed,
  findProductIdBy,
  findProductIdBySuccess,
  findProductIdByFailed,
  findWheelers,
  findWheelersSuccess,
  findWheelersFailed,
  findModelById,
  findModelByIdFailed,findModelByIdSuccess
} = slice.actions;
